import { get } from 'lodash';
import { type IAsyncService } from '../context/IAsyncService.ts';

/**
 * Estrae il valore dei campi annidati nell'oggetto ritornato dai servizi
 * e lo rimappa in root, utilizzando la chiave ricostruita.
 */
export function asyncServiceMapResults(data: any, service: IAsyncService) {
  if (!service) return data;
  if (!data) return data;

  for (const output of service.outputs) {
    if (isNested(output.sourcePath ?? output.name)) {
      // Prendiamo il valore originale, definito in sourceField se presente, altrimenti già nel name
      const value = get(data, output.sourcePath ?? output.name);
      // Rimappiamo il valore in root (name = <padre>@@DOT@@<figlio>))
      data[output.name ?? output.sourcePath] = value;
    }
  }

  return data;
}

function isNested(output: string) {
  return output.includes('.');
}
